import request from '@/utils/request'
import api from '../api'

export class Behalf {
  batchCreate(data) {
    return request({
      url: api.behalf.batchCreate,
      method: 'post',
      data
    })
  }
  verify(data) {
    return request({
      url: api.behalf.verify,
      method: 'post',
      data
    })
  }
  batchSearch(data) {
    return request({
      url: api.behalf.batchSearch,
      method: 'post',
      data
    })
  }
  calculateAmount(data) {
    return request({
      url: api.behalf.calculateAmount,
      method: 'post',
      data
    })
  }
  detailExport(data) {
    return request({
      url: api.behalf.detailExport,
      method: 'post',
      data
    })
  }
  singleSearch(data) {
    return request({
      url: api.behalf.singleSearch,
      method: 'post',
      data
    })
  }
}

